var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRejectOrder = function SvgRejectOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM21.7668 21.7666C21.1593 22.3741 20.1744 22.3741 19.5669 21.7666L16.0002 18.1999L12.4335 21.7666C11.826 22.3741 10.8411 22.3741 10.2336 21.7666C9.6261 21.1591 9.6261 20.1742 10.2336 19.5667L13.8003 16L10.2334 12.4331C9.62591 11.8256 9.62591 10.8407 10.2334 10.2332C10.8409 9.62569 11.8258 9.62569 12.4333 10.2332L16.0002 13.8001L19.5669 10.2334C20.1744 9.6259 21.1593 9.6259 21.7668 10.2334C22.3743 10.8409 22.3743 11.8258 21.7668 12.4333L18.2001 16L21.7668 19.5667C22.3743 20.1742 22.3743 21.1591 21.7668 21.7666Z",
    fill: "currentColor"
  })));
};
export default SvgRejectOrder;